import { ArrowUpRight } from '@phosphor-icons/react/dist/ssr/ArrowUpRight'
import { CalendarDots } from '@phosphor-icons/react/dist/ssr/CalendarDots'
import { siteConfig } from '@/config/site'

const linkClassName =
  'inline-flex w-full items-center justify-center gap-2 rounded-full border border-black bg-black px-5 py-3 text-center text-sm font-semibold leading-5 text-white transition-[transform,background-color] duration-200 [transition-timing-function:cubic-bezier(0.2,0,0,1)] hover:bg-[#202020] active:scale-[0.98] focus-visible:ring-2 focus-visible:ring-[var(--ring)] focus-visible:ring-offset-2 focus-visible:outline-none'

type Props = {
  /** `fixed` — dock below lg only; `inline` — right column with content sheet (lg+). */
  variant: 'fixed' | 'inline'
}

export const CaseStudyBookCallCta = ({ variant }: Props) => {
  const link = (
    <a
      href={siteConfig.calendlyUrl}
      rel="noreferrer"
      target="_blank"
      aria-label="Schedule a call (opens in new tab)"
      className={
        variant === 'fixed'
          ? `${linkClassName} pointer-events-auto max-w-[448px]`
          : `${linkClassName} pointer-events-auto`
      }
    >
      <CalendarDots className="size-4 shrink-0 text-white" weight="regular" aria-hidden />
      Book a call
      <ArrowUpRight className="size-4 shrink-0 text-white" aria-hidden />
    </a>
  )

  if (variant === 'inline') {
    return link
  }

  return (
    <div
      className={
        /* Mobile: no floating dock — primary CTAs stay in page flow. md–lg: dock above rail/bottom inset. */
        'pointer-events-none fixed left-0 right-0 z-40 hidden justify-center px-4 md:flex lg:hidden ' +
        'md:bottom-[calc(16px+env(safe-area-inset-bottom,0px))] md:left-[72px] md:right-0'
      }
    >
      {link}
    </div>
  )
}
